import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { MenuSearchRequestBody, MenuSearchResponse } from "./types";

export class MenuSearchAPI extends BaseAPI<
  MenuSearchRequestBody,
  MenuSearchResponse
> {
  protected route = ApiRoutes.menu.search;
  protected method = RequestMethod.POST;
}
